import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=36d47e0e&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=36d47e0e&prod&lang=less&scoped=true&"
import style1 from "./detail.vue?vue&type=style&index=1&id=36d47e0e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d47e0e",
  null
  
)

export default component.exports